module.exports = "https://dashboard.cdn.gifty.nl/6415/images/plane.svg?1641bc4936963950c3c54b2f62f5e44c";